import styled from 'styled-components'

import { calendarGlyph } from 'Assets/Svg/icons'

export const CalendarIcon = styled(calendarGlyph)``
